<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-form @submit.prevent="submit()">
          <v-card-title class="headline gradiente lighten-2 elevation-3">
            <span class="white--text">
              {{
                visitPerson
                  ? 'Editar invitado'
                  : `${$t('appointments.add_guest')}`
              }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="firstNameErrors"
                        prepend-icon="people"
                        v-model="$v.visitPersonForm.firstName.$model"
                        :label="$t('appointments.first_name')"
                        clearable
                        counter
                        maxlength="100"
                        required
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="lastNameErrors"
                        prepend-icon="people"
                        v-model="$v.visitPersonForm.lastName.$model"
                        :label="$t('appointments.last_name')"
                        clearable
                        counter
                        maxlength="100"
                        required
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="emailErrors"
                        prepend-icon="email"
                        v-model="$v.visitPersonForm.email.$model"
                        :label="$t('appointments.email')"
                        clearable
                        counter
                        maxlength="255"
                        required
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn :disabled="working.wUpdate" flat @click="cancel">
              {{ $t('generic.cancel') }}
            </v-btn>
            <v-btn
              :disabled="working.wUpdate"
              color="primary darken-1"
              type="submit"
              flat
            >
              {{ $t('generic.save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..." />
    <success v-model="toast.success" text="Creación Exitosa" />
    <error v-model="toast.failed" :text="toast.eMessage" />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import DateTimePicker from '../Notices/Tools/DateTimePicker2'

export default {
  props: ['value', 'visitPerson', 'visit', 'local'],
  components: {
    loading,
    success,
    error,
    DateTimePicker,
  },
  validations: {
    visitPersonForm: {
      firstName: { required },
      lastName: { required },
      email: { required },
    },
  },
  watch: {
    value() {
      if (this.value) {
        if (this.visitPerson !== null) {
          this.visitPersonForm.firstName = this.visitPerson.firstName
          this.visitPersonForm.lastName = this.visitPerson.lastName
          this.visitPersonForm.email = this.visitPerson.email
        }
      }
    },
  },
  mounted() {},
  data: () => ({
    visitPersonForm: {
      firstName: '',
      lastName: '',
      email: '',
    },
    working: {
      wUpdate: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: '',
    },
  }),
  methods: {
    getPromise() {
      if (this.visitPerson) {
        return this.$store.dispatch('visits/updateVisitPerson', {
          idVisit: this.visitPerson.idVisit,
          idVisitPerson: this.visitPerson.id,
          data: this.visitPersonForm,
        })
      }

      return this.$store.dispatch('visits/addVisitPerson', {
        idVisit: this.visit ? this.visit.id : 0,
        data: this.visitPersonForm,
      })
    },
    submit(event = null) {
      this.$v.visitPersonForm.$touch()
      if (this.$v.visitPersonForm.$invalid) {
        return
      }

      if (this.local) {
        this.$emit(
          this.visitPerson ? 'updated' : 'created',
          true,
          this.visitPersonForm
        )
        this.close()
      } else {
        this.working.wUpdate = true
        this.getPromise()
          .then((response) => {
            this.working.wUpdate = false
            this.$v.visitPersonForm.$reset()
            if (this.visitPerson) {
              this.$emit('updated', true, response.data)
            } else {
              this.$emit('created', true, response.data)
            }
            this.close()
          })
          .catch(() => {
            this.working.wUpdate = false
            this.$emit('created', false, null)
          })
      }
    },
    cancel() {
      this.$emit('cancelled')
      this.close()
    },
    close() {
      this.$v.visitPersonForm.$reset()
      this.visitPersonForm = {
        firstName: '',
        lastName: '',
        email: '',
      }
    },
  },
  computed: {
    firstNameErrors() {
      if (
        !this.$v.visitPersonForm.firstName.$dirty ||
        this.visitPersonForm.firstName
      )
        return []
      return ['Nombre obligatorio']
    },
    lastNameErrors() {
      if (
        !this.$v.visitPersonForm.lastName.$dirty ||
        this.visitPersonForm.lastName
      )
        return []
      return ['Apellidos obligatorios']
    },
    emailErrors() {
      if (!this.$v.visitPersonForm.email.$dirty) return []
      if (!this.visitPersonForm.email) {
        return ['Correo electrónico obligatorio']
      }

      var emailReg =
        /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])$/i
      if (!emailReg.test(this.visitPersonForm.email)) {
        return ['Correo electrónico incorrecto']
      }
      return []
    },
  },
}
</script>

<style></style>
